let set = new Set()

let init = false

export default {
    add(id) {
        if (!init) {
            setTimeout(() => {
                // console.log(set)
            }, 0)
            init = true
        }
        set.add(id)
    }
}